/**
 * https://www.freecodecamp.org/news/javascript-debounce-example/
 */
// export default (func, timeout = 100) => {
//   let timer

//   return (...args) => {
//     clearTimeout(timer)

//     timer = setTimeout(() => {
//       func.apply(this, args)
//     }, timeout)
//   }
// }
const debounce = (func, delay) => {
    let inDebounce;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
};

export default debounce;
